/**
 * @desc setTrackingNumber
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/outPlanMaster/outPlan/setTrackingNumber`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
